export const labels = {
  es: {
    USResident: "¿Es residente de Estados Unidos?",
    residenceCountry: "País de residencia fiscal",
    firstCitizenship: "¿Cuál es su ciudadanía principal?",
    additionalCitizenshipBool: "¿Tiene otra ciudadanía adicional?",
    additionalCitizenship: "Ciudadanía adicional",
    documentType: "Tipo de documento de identidad",
    documentNumber: "Número de documento",
    passportNumber: "Número de pasaporte",
    documentCountry: "País de emisión del documento",
    documentEmisionDate: "Fecha de emisión",
    documentExpirationDate: "Fecha de vencimiento",
    documentFront: "Frente",
    passportFront: "Primera página",
    documentBack: "Dorso",
    passportBack: "Segunda página (si corresponde)",
    taxId: "Identificación fiscal (CUIT / CUIL / TAX ID)",
    preconfirmationTaxId: "Identificación fiscal",
    socialSecurityNumber: "Número de seguridad social (SSN)",
  },

  en: {
    USResident: "Are you a resident of the United States?",
    residenceCountry: "Tax Residency Country",
    firstCitizenship: "What is your primary citizenship?",
    additionalCitizenshipBool: "Do you have any additional citizenship?",
    additionalCitizenship: "Additional citizenship",
    documentType: "Type of ID",
    documentNumber: "Document Number",
    passportNumber: "Passport Number",
    documentCountry: "Document Issuing Country",
    documentEmisionDate: "Date of issuance",
    documentExpirationDate: "Expiration date",
    documentFront: "Front",
    passportFront: "First page",
    documentBack: "Back",
    passportBack: "Second page (if applicable)",
    taxId: "Tax identification number (CUIT / CUIL / TAX ID)",
    preconfirmationTaxId: "Tax identification number",
    socialSecurityNumber: "Social Security Number (SSN)",
  },
};

export const title = {
  es: "Identificación",
  en: "Identification",
};

export const texts = {
  es: {
    section1: "Sección 1: Estado de residencia y ciudadanía",
    section2: "Sección 2: Documentación e identificación",
    documentImagesLabelTitle: {
      AR: "Cargá fotos del frente y dorso de tu Documento de identidad.",
      US: "Cargá fotos de tu pasaporte.",
    },
    documentImagesLabelBody: {
      AR: "Asegurate de que las fotos sean del mismo documento que completaste anteriormente. Deben estar bien iluminadas y legibles, sin sombras ni reflejos.",
      US: "Deben estar bien iluminadas y legibles, sin sombras ni reflejos.",
    },
  },

  en: {
    section1: "Section 1: Residency and Citizenship Status",
    section2: "Section 2: Documentation and Identification",
    documentImagesLabelTitle: {
      AR: "Upload photos of the front and back of your ID.",
      US: "Upload photos of your passport.",
    },
    documentImagesLabelBody: {
      AR: "Make sure the photos are of the same document you completed earlier. They should be well-lit and legible, without shadows or reflections.",
      US: "They should be well-lit and legible, without shadows or reflections.",
    },
  },
};

export const placeholders = {
  es: {
    USResident: "Seleccioná una opción",
    residenceCountry: "Seleccioná una opción",
    firstCitizenship: "Seleccioná una opción",
    additionalCitizenshipBool: "Seleccioná una opción",
    additionalCitizenship: "Seleccioná una opción",
    documentType: "Seleccioná una opción",
    documentNumber: "XXXXXXXX",
    passportNumber: "XXXXXXXXX",
    documentCountry: "Seleccioná una opción",
    documentEmisionDate: "DD/MM/AAAA",
    documentExpirationDate: "DD/MM/AAAA",
    documentFront: "",
    documentBack: "",
    taxId: "XX-XXXXXXXX-X",
    socialSecurityNumber: "XXX-XX-XXXX",
  },

  en: {
    USResident: "Select an option",
    residenceCountry: "Select an option",
    firstCitizenship: "Select an option",
    additionalCitizenshipBool: "Select an option",
    additionalCitizenship: "Select an option",
    documentType: "Select an option",
    documentNumber: "XXXXXXXXX",
    passportNumber: "XXXXXXXXXX",
    documentCountry: "Select an option",
    documentEmisionDate: "DD/MM/YYYY",
    documentExpirationDate: "DD/MM/YYYY",
    documentFront: "",
    documentBack: "",
    taxId: "XX-XXXXXXXX-X",
    socialSecurityNumber: "XXX-XX-XXXX",
  },
};

export const fileInfoText = (maxFileSize: number) => ({
  es: `Cargá archivos JPG, PNG, HEIC, HEIF o PDF de hasta ${maxFileSize}mb.`,
  en: `Upload a JPG, PNG, HEIC, HEIF, or PDF file up to ${maxFileSize}mb.`,
});
